import { render, staticRenderFns } from "./CannotUseTheTel.vue?vue&type=template&id=3c122a72&"
import script from "./CannotUseTheTel.vue?vue&type=script&lang=ts&"
export * from "./CannotUseTheTel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports